import React from "react";
import useTranslation from "next-translate/useTranslation";
import { RadioGroup } from "@headlessui/react";
import { Controller } from "react-hook-form";
import classNames from "lib/classNames";

export default function Radios({
  name,
  label,
  control,
  errors,
  options,
  labelDisplay,
  required = false,
}) {
  const { t } = useTranslation("common");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <RadioGroup value={value} onChange={onChange}>
          <RadioGroup.Label
            className={
              labelDisplay === "invisible"
                ? "sr-only"
                : "inline-block mb-1 font-important font-medium uppercase text-sm"
            }
          >
            {label}
            {required && (
              <>
                {" "}
                <span className="text-primary">*</span>
              </>
            )}
          </RadioGroup.Label>
          <div className="flex flex-col gap-2">
            {Object.keys(options).map((option) => {
              return (
                <RadioGroup.Option
                  key={option}
                  value={option}
                  className="cursor-pointer"
                >
                  {({ checked }) => (
                    <div className={classNames("flex items-center gap-4")}>
                      <span className="flex items-center justify-center p-2  border border-primary bg-gray-100 rounded-full transition-colors">
                        <span
                          className={classNames(
                            "h-2 w-2 rounded-full transition-colors",
                            checked && "bg-primary"
                          )}
                        />
                        <span className="sr-only">
                          {checked ? "Coché" : "Non Coché"}
                        </span>
                      </span>
                      <span>{options[option]}</span>
                    </div>
                  )}
                </RadioGroup.Option>
              );
            })}
          </div>
          {errors && (
            <p
              role="alert"
              className="block mt-1 text-sm text-red-500 font-semibold"
            >
              {errors.message}
            </p>
          )}
        </RadioGroup>
      )}
      rules={{
        required: required ? t("form.required") : false,
      }}
    />
  );
}
